import { PlatformConfiguration } from "@/admin/settings/PlatformConfiguration.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_simple/configuration")({
    component: PlatformConfiguration,
});
